import { Controller } from "@hotwired/stimulus"

// Owner-only dashboard cards: append an eye-slash badge right after the
// card's title so owners know the card isn't visible to other project
// roles. One hook on the card wrapper covers every owner-only widget
// (finance, risk, activity) and any added later — no per-partial edits.
// The wrapper only wires this controller for owner-only widgets shown to
// an owner, so its mere presence means "owner-only".
export default class extends Controller {
  connect() {
    const title = this.element.querySelector("h2")
    if (!title || title.dataset.ownerBadged) return
    title.dataset.ownerBadged = "1"

    const badge = document.createElement("span")
    badge.className = "text-gray-400 cursor-default shrink-0 inline-flex items-center"
    badge.setAttribute("data-tip", "This card is only visible to owner users")
    badge.setAttribute("data-tip-align", "top")
    badge.innerHTML =
      '<svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
      '<path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.243 4.243L9.88 9.88"/></svg>'
    title.insertAdjacentElement("afterend", badge)
  }
}
